var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9092 17.6622L17.7889 15.3384C17.6151 15.2089 17.3765 15.3783 17.4421 15.5859L17.7215 16.4631H6.27972L13.6539 9.08889L14.1843 10.1151C14.2836 10.3085 14.5728 10.2597 14.6038 10.045L15.1671 6.19474C15.1883 6.04662 15.0615 5.91979 14.9134 5.94107L11.064 6.50429C10.8493 6.53534 10.8006 6.82449 10.9939 6.92382L11.8596 7.37085L4.52443 14.706V3.25447L5.47347 3.55693C5.68013 3.62256 5.85043 3.38486 5.72005 3.21013L3.39533 0.0898046C3.30574 -0.0299349 3.12658 -0.0299349 3.037 0.0898046L0.713163 3.21013C0.583667 3.38397 0.753079 3.62256 0.960628 3.55693L2.04094 3.21279V17.7039C2.04094 18.3895 2.59707 18.9457 3.28269 18.9457H17.8093L17.4421 20.0978C17.3765 20.3045 17.6142 20.4748 17.7889 20.3444L20.9092 18.0197C21.029 17.9301 21.029 17.7509 20.9092 17.6614V17.6622Z",
    fill: "url(#paint0_linear_7873_9364)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7873_9364",
    x1: 10.8335,
    y1: 20.3509,
    x2: 10.8335,
    y2: -4.92622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018EC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReach);
export default __webpack_public_path__ + "static/media/reach.9ba0637a4b52f83135cff9e2ca5815d1.svg";
export { ForwardRef as ReactComponent };